import * as yup from "yup";

export const ACVEstimatorSchema = yup.object({
  constructionYear: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? undefined : Number(value)))
    .typeError("Must be a valid number")
    .integer()
    .min(1600, "Must have been constructed after 1600")
    .max(new Date().getFullYear(), "Cannot estimate value of future construction")
    .required(),

  constructionType: yup.string().oneOf(["F", "M"]).required(),

  squareFootage: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? undefined : Number(value)))
    .typeError("Must be a valid number")
    .integer()
    .min(10, "Must be larger than 10 sq.ft.")
    .required(),

  zip: yup
    .string()
    .matches(/^1[0-4]\d{3}$/, "Must be a valid NYS ZIP Code")
    .required(),

  numFamilies: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? undefined : Number(value)))
    .typeError("Must be a valid number")
    .integer()
    .min(1)
    .required(),
});
